<template>
  <b-card body-class="px-3">
    <campaign-card-header :campaign="campaign"/>
    <b-row>
      <!-- Left -->
      <b-col cols="12" md="8">

        <!-- Dashboard cards at the top on small screens -->
        <welcome-card v-for="(card, i) in Array.isArray(campaign.dashboardCards) ? campaign.dashboardCards : []"
          :key="i" class="my-3 d-block d-md-none" :card="card"/>

        <schedule-linkedin-card v-if="canScheduleLinkedInPosts && isDemoSite" class="my-3" :scheduleModalID="`schedule-campaign-${campaign.id}`">
          <template v-slot:schedule-posts-modal>
            <schedule-posts-modal
              :jobIDs="[ ...(Array.isArray(campaign.dashboardJobs) ? campaign.dashboardJobs : []), ...campaign.jobs ].slice(0, sliceItems.jobs).map(({ id }) => id)"
              :contentShareIDs="Array.isArray(campaign.contentShares) ? campaign.contentShares.slice(0, sliceItems.contentShares).map(({ id }) => id) : null"
              @modal-close="() => $bvModal.hide(`schedule-campaign-${campaign.id}`)"/>
          </template>
        </schedule-linkedin-card>

        <template v-if="campaign && Array.isArray(campaign.jobs) && campaign.jobs.length && !isEY">
          <job-card
            class="my-3"
            v-for="job in [ ...(Array.isArray(campaign.dashboardJobs) ? campaign.dashboardJobs : []), ...campaign.jobs ].slice(0, sliceItems.jobs)"
            :key="job.id"
            :job="job"
          />

          <div class="d-flex justify-content-center align-items-center my-4">
            <b-btn :to="{ name: 'CampaignJobIndex', query: isBallastNedam ? undefined : { campaignID: campaign.id } }"
              size="sm" variant="outline-primary">{{ $t('campaign.buttons.view_all_jobs') }}</b-btn>
          </div>
        </template>

        <!-- Content -->
        <template v-if="campaign && Array.isArray(campaign.contentShares) && campaign.contentShares.length">
          <b-row class="card-deck">
            <b-col class="my-3" cols="12" lg="6" v-for="entry in campaign.contentShares.slice(0, sliceItems.contentShares)" :key="entry.id">
              <content-card :campaignID="campaign.id" :entry="entry" @trackShare="data => trackContentSharedEvent(entry, data)"/>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center align-items-center my-4">
            <b-btn :to="{ name: 'CampaignContentShareIndex', query: { campaignID: campaign.id } }"
              size="sm" variant="outline-primary">{{ $t('campaign.buttons.view_all_content') }}</b-btn>
          </div>
        </template>
      </b-col>

      <!-- Right -->
      <b-col cols="12" md="4">

        <div
          v-for="el in (campaign.components || []).filter(el => isCollectiveValid(el))"
          :key="el.id"
        >
          <div>
            <csr-initiative
              :isPreview="false"
              :isCampaign="true"
              :monthlyTotalPoints="totalPoints"
              :csrInitiative="el.collectiveGoal"
              class="my-3"
            />
          </div>
        </div>

        <div
          v-for="el in (campaign.components || []).filter(el => isCollectiveGoalTemplateValid(el))"
          :key="el.id"
        >
            <collective-goal
              :progress="collectiveGoalProgress"
              :template="el.collectiveGoal"
              class="my-3"
            />
        </div>

        <!-- <csr-initiative
          class="my-3"
          :hideYear="true"
          :isPreview="true"
        /> -->

        <!-- Dashboard cards at the top of sidebar on larger screens -->
        <welcome-card v-for="(card, i) in Array.isArray(campaign.dashboardCards) ? campaign.dashboardCards : []"
          :key="i" class="my-3 d-none d-md-block" :card="card"/>

        <b-card class="my-3" v-if="campaign.event && campaign.event.id && (isDemoSite || (campaign.event.endDate > (new Date()))) && !isCelonis">
          <h4 class="text-uppercase">{{ $t('campaign.titles.referral-jam') }}</h4>
          <referral-jam-card :event="campaign.event"/>
        </b-card>

        <b-card class="my-3" v-if="campaign.leaderboard && !isTaylorAndFrancis">
          <h4 class="text-uppercase">{{ $t('campaign.titles.leaderboard') }}</h4>

          <leaderboard-list v-if="!campaign.table" :rows="leaderboardRows" :viewModalID="`leaderboard-details-${campaign.id}`"
            :raffleMode="campaign.leaderboard.raffleMode" :prizes="campaign.leaderboard.prizes"/>
          <leaderboard-table-list v-else :rows="campaign.table.filter(el => el && el.user)" :viewModalID="`leaderboard-details-${campaign.id}`"
            :raffleMode="campaign.leaderboard.raffleMode" :prizes="campaign.leaderboard.prizes"/>

          <!-- TODO: Prepare for multiple leaderboards, name the modal uniquely -->
          <div class="d-flex flex-row justify-content-center align-items-center w-100">
            <b-btn v-if="!campaign.table" class="text-primary px-0" size="sm" v-b-modal="`leaderboard-details-${campaign.id}`" variant="link">
              {{ $t('campaign.buttons.view_all') }} ({{ leaderboardRows.length }})
            </b-btn>
            <b-btn v-else class="text-primary px-0" size="sm" v-b-modal="`leaderboard-details-${campaign.id}`" variant="link">
              {{ $t('campaign.buttons.view_all') }} ({{ (Array.isArray(campaign.table) ? campaign.table : []).filter(el => el && el.user).length }})
            </b-btn>
          </div>
          <b-modal :id="`leaderboard-details-${campaign.id}`" :title="$t('campaign.titles.leaderboard')" hide-footer lazy size="xl">
            <leaderboard v-if="!campaign.table" :rows="leaderboardRows"
              :raffleMode="campaign.leaderboard.raffleMode" :prizes="campaign.leaderboard.prizes" :scores="campaign.leaderboard.scores"
              :campaignID="campaign.id"/>
            <!--leaderboard-table-v2 v-else-if="isEXPD8" :rows="campaign.table.filter(el => el && el.user)" :raffleMode="campaign.leaderboard.raffleMode" :prizes="campaign.leaderboard.prizes" :scores="campaign.leaderboard.scores"
              :campaignID="campaign.id"/ -->
            <leaderboard-table v-else :rows="campaign.table.filter(el => el && el.user)" :raffleMode="campaign.leaderboard.raffleMode" :prizes="campaign.leaderboard.prizes" :scores="campaign.leaderboard.scores"
              :campaignID="campaign.id"/>
          </b-modal>
        </b-card>

        <b-card class="my-3" v-if="showLiveFeed && campaign.leaderboard">
          <h4 class="text-uppercase">{{ $t('campaign.titles.live-feed') }}</h4>

          <template v-if="historyItems && Array.isArray(historyItems.entries)">
            <campaign-history-block :historyItems="historyItems.entries.slice(campaignHistoryLimit * (campaignHistoryPage - 1), campaignHistoryLimit * campaignHistoryPage)" />
            <div class="d-flex justify-content-center align-items-middle p-3">
              <b-pagination
                v-model="campaignHistoryPage"
                :total-rows="(historyItems || {}).total && historyItems.total > campaignHistoryTotal ? campaignHistoryTotal : (historyItems || {}).total || 0"
                :per-page="campaignHistoryLimit"
              />
            </div>
          </template>
          <template v-else-if="Array.isArray(campaign.leaderboard.history) && campaign.leaderboard.history.length">
            <live-feed hide-pagination stacked
              :users="campaign.users" :history="campaign.leaderboard.history.slice(0, 8)" />
            <div class="d-flex flex-row justify-content-center align-items-center w-100">
              <!-- TODO: The campaign id has to be added to the modal id in order to make unique -->
              <b-btn class="text-primary" size="sm" variant="link" v-b-modal="`live-feed-details-${campaign.id}`" >{{ $t('campaign.buttons.view_more') }}</b-btn>
            </div>
            <b-modal :id="`live-feed-details-${campaign.id}`" title="Live Feed" hide-footer lazy>
              <live-feed :users="campaign.users" :history="campaign.leaderboard.history" :limit="50"/>
            </b-modal>
          </template>
          <div v-else class="d-flex flex-column justify-content-center align-items-center my-2 w-100">
            <p class="m-0">{{ $t('campaign.placeholders.live-feed') }}</p>
          </div>
        </b-card>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import _sortBy from 'lodash/sortBy';
import { mapRoot, mapPreferences } from '@src/mixins/root';
// import { startOfWeek } from 'date-fns';
import CampaignCardHeader from '@/components/campaign-dashboard/campaign-card-header';
import Leaderboard from '@src/components/referral-jam/Leaderboard';
import LeaderboardTable from '@src/components/campaign/Leaderboard';
import LeaderboardTableV2 from '@src/components/campaign/LeaderboardV2';
import LeaderboardList from '@src/components/referral-jam/LeaderboardList';
import LeaderboardTableList from '@src/components/campaign/LeaderboardList';
import JobCard from '@/components/campaign/job-card';
import LiveFeed from '@/components/referral-jam/LiveFeed';
import ContentCard from '@/components/content-share/ContentCard';
import ReferralJamCard from '@/components/campaign-dashboard/ReferralJamCard';
import WelcomeCard from '@/components/dashboard/Welcome-Card';
import scheduleLinkedInMixin from '@src/mixins/scheduleLinkedIn';
import CsrInitiative from '@/components/dashboard/CsrInitiative';
import CollectiveGoal from '@/components/dashboard/collective-goal';
import CampaignHistoryBlock from '@/components/campaign-admin/CampaignHistoryBlock.vue';

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  mixins: [
    scheduleLinkedInMixin,
  ],
  components: {
    CampaignCardHeader,
    JobCard,
    ContentCard,
    LiveFeed,
    Leaderboard,
    LeaderboardTable,
    LeaderboardTableV2,
    LeaderboardList,
    LeaderboardTableList,
    ReferralJamCard,
    WelcomeCard,
    CsrInitiative,
    CollectiveGoal,
    CampaignHistoryBlock
  },
  mounted() {
    console.log({ campaign: this.campaign, totalPoints: this.totalPoints });
  },
  data: () => ({
    campaignHistoryPage: 1,
    campaignHistoryLimit: 4,
    campaignHistoryTotal: 48
  }),
  computed: {
    ...mapRoot([ 'origin', 'isDemoSite', 'isTaylorAndFrancis', 'isEY', 'isCelonis', 'isEXPD8', 'isBallastNedam' ]),
    ...mapPreferences([ 'showLiveFeed' ]),
    totalPoints() {
      const { leaderboard } = this.campaign;
      const { components } = this.campaign || {};
      const { collectiveGoal } = ((Array.isArray(components) ? components : []).find(el => this.isCollectiveValid(el)) || {});
      console.log({ collectiveGoal });
      const { history, scores: leaderboardScores } = leaderboard || {};
      const { scores: collectiveGoalScores } = collectiveGoal || {};
      const scores = collectiveGoalScores || leaderboardScores || null;
      console.log({ scores });
      if (Array.isArray(scores) && scores.length && Array.isArray(history) && history.length) {
        return history.reduce((sum, el) => {
          if (!el.eventName) return 0;
          const { value } = scores.find(({ eventNames }) => Array.isArray(eventNames) && eventNames.includes(el.eventName)) || {};
          return sum + (value || 0);
        }, 0);
      }
      return 0;
    },
    collectiveGoalProgress() {
      const { analytics, components } = this.campaign || {};
      const { collectiveGoal } = ((Array.isArray(components) ? components : []).find(el => this.isCollectiveGoalTemplateValid(el)) || {});
      const { data } = analytics || {};
      const { conversion, eventNames } = collectiveGoal || {};
      console.log({ data, conversion, eventNames });
      if (!data || !conversion || !Array.isArray(eventNames) || !eventNames.length) return 0;
      return Math.floor(eventNames.reduce((sum, eventName) => sum + (data[eventName] || 0), 0) / conversion);
    },
    canScheduleLinkedInPosts() {
      const { sitePreferences, preferences } = this.company || {};
      const { preferences: campaignPreferences } = this.campaign || {};
      const { canScheduleLinkedInPosts } = { ...sitePreferences, ...preferences, ...campaignPreferences };
      return canScheduleLinkedInPosts === true;
    },
    leaderboardRows() {
      const { leaderboard, users } = this.campaign;
      const { history, scores } = leaderboard;

      // const thisDay = {};
      // const thisWeek = {};
      // const dayStart = null;
      // const weekStart = null;
      const rows = (Array.isArray(users) ? users : []).map(({ id, fullName: name }) => {
        const scoreIDs = {};
        const events = (Array.isArray(history) ? history : []).reduce((rollup, row) => {
          let scoreID = null;
          if (row && row.userID === id && row.eventName) {
            const { eventName, jobID, contentShareID } = row;
            // const { eventName, jobID, contentShareID, timestamp } = row;
            // const time = new Date(timestamp);
            // console.log({ timestamp: ((new Date(timestamp)).getTime() / 1000) });

            if (jobID || contentShareID) {
              scoreID = jobID ? `JOB_${jobID}` : `CONTENT_${contentShareID}`;
              scoreIDs[scoreID] = (scoreIDs[scoreID] || 0) + 1;
            }

            const { maximum } = scores.find(({ eventNames }) => eventNames.includes(eventName)) || {};
            // const { weeklyMaximum, dailyMaximum } = scores.find(({ eventNames }) => eventNames.includes(eventName)) || {};
            if (!scoreID || !maximum || (maximum && scoreID && scoreIDs[scoreID] <= maximum)) {
              // if (weeklyMaximum || dailyMaximum) {
              //   console.log({ start: startOfWeek(time).getTime() });
              // } else {
              rollup[eventName] = (rollup[eventName] || 0) + 1;
              // }
            }
          }
          return rollup;
        }, {});

        const total = Object.keys(events).reduce((t, eventName) => {
          const value = (Array.isArray(scores) ? scores : []).reduce((t, { eventNames, disabled, value }) => {
            if (Array.isArray(eventNames) && eventNames.includes(eventName) && !disabled && value > 0) {
              return t + value;
            } else {
              return t;
            }
          }, 0);
          return t + (value * (events[eventName] || 0));
        }, 0);

        return { id, name, ...events, total };
      });

      return _sortBy(rows, [ 'total' ]).reverse();
    },
    sliceItems() {
      const { jobs, contentShares } = this.campaign || {};
      if (this.isEY) {
        return { jobs: 0, contentShares: 4 };
      }
      if (Array.isArray(jobs) && jobs.length && Array.isArray(contentShares) && contentShares.length) {
        return { jobs: 3, contentShares: 2 };
      } else if (Array.isArray(jobs) && jobs.length) {
        return { jobs: 4, contentShares: 0 };
      } else if (Array.isArray(contentShares) && contentShares.length) {
        return { jobs: 0, contentShares: 4 };
      } else {
        return { jobs: 0, contentShares: 0 };
      }
    },
    historyItems() {
      const { history } = this.campaign || {};
      const { historyItems } = history || {};
      return historyItems;
    }
  },
  methods: {
    async trackContentSharedEvent({ id: contentShareID }, { channel }) {
      try {
        await this.$root.captureLog({
          eventName: 'CONTENT_SHARED',
          contentShare: { id: contentShareID },
          user: { self: true },
          dataHash: { channel },
        });
      } catch (err) {
        this.$log.error(err);
      }
    },
    isCollectiveValid(el) {
      return el.collectiveGoal && el.collectiveGoal.description && el.collectiveGoal.headline && el.collectiveGoal.icon && el.collectiveGoal.units && el.collectiveGoal.status === 'ACTIVE';
    },
    isCollectiveGoalTemplateValid(el) {
      console.log({ el });
      return el.collectiveGoal && el.collectiveGoal.description && el.collectiveGoal.headline && el.collectiveGoal.icon && el.collectiveGoal.goal;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-dashboard/campaign-card.vue